import { PureComponent } from 'react';
import { getParticipantById } from '../../base/participants/functions';
import { sendMessage, setPrivateMessageRecipient } from '../actions';
/**
 * Abstract class for the dialog displayed to avoid mis-sending private messages.
 */
export class AbstractChatPrivacyDialog extends PureComponent {
    /**
     * Instantiates a new instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this._onSendGroupMessage = this._onSendGroupMessage.bind(this);
        this._onSendPrivateMessage = this._onSendPrivateMessage.bind(this);
    }
    /**
     * Callback to be invoked for cancel action (user wants to send a group message).
     *
     * @returns {boolean}
     */
    _onSendGroupMessage() {
        this.props._onSendMessage(this.props.message);
        return true;
    }
    /**
     * Callback to be invoked for submit action (user wants to send a private message).
     *
     * @returns {void}
     */
    _onSendPrivateMessage() {
        const { message, _onSendMessage, _onSetMessageRecipient, _participant, isFromVisitor, displayName, participantID } = this.props;
        if (isFromVisitor) {
            // For visitors, create a participant object since they don't exist in the main participant list
            const visitorParticipant = {
                id: participantID,
                name: displayName,
                isVisitor: true
            };
            _onSetMessageRecipient(visitorParticipant);
        }
        else {
            _onSetMessageRecipient(_participant);
        }
        _onSendMessage(message);
        return true;
    }
}
/**
 * Maps part of the props of this component to Redux actions.
 *
 * @param {Function} dispatch - The Redux dispatch function.
 * @returns {IProps}
 */
export function _mapDispatchToProps(dispatch) {
    return {
        _onSendMessage: (message) => {
            dispatch(sendMessage(message, true));
        },
        _onSetMessageRecipient: (participant) => {
            dispatch(setPrivateMessageRecipient(participant));
        }
    };
}
/**
 * Maps part of the Redux store to the props of this component.
 *
 * @param {IReduxState} state - The Redux state.
 * @param {IProps} ownProps - The own props of the component.
 * @returns {IProps}
 */
export function _mapStateToProps(state, ownProps) {
    return {
        _participant: ownProps.isFromVisitor ? undefined : getParticipantById(state, ownProps.participantID)
    };
}
